import { useCallback, useMemo, useState } from 'react';
import { getNonStructuredCoursesListRequest } from '../../../../api/requests/sectionsMaintainer';
import { Schedule } from '../../../../types/schedule';
import {
  CourseType,
  FormDataResponseType,
} from '../../../../types/sectionMaintainerTypes';
import { SelectOptionType } from '@octano/global-ui';
import { NonStructuredSectionForm } from '../types';

export function useNonStructuredSectionForm(
  formData: FormDataResponseType | undefined,
  scopedForm: NonStructuredSectionForm | undefined,
) {
  const [coursesOptions, setCoursesOptions] = useState<SelectOptionType[]>([]);
  const [courseNamesOptions, setCourseNamesOptions] = useState<
    SelectOptionType[]
  >([]);
  const [courses, setCourses] = useState<CourseType[]>([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  const facultyOptions = scopedForm?.schools ?? [];
  const campusOptions = scopedForm?.campuses ?? [];

  const schedulesOptions = useMemo(() => {
    return (
      formData?.schedules.map((row: Schedule) => ({
        value: row.id ?? '',
        label: row.name,
      })) || []
    );
  }, [formData]);

  const loadCourses = useCallback(
    async (facultyId?: number) => {
      setLoadingCourses(true);
      const { data } = await getNonStructuredCoursesListRequest(facultyId);
      if (data) {
        setCourses(data);
        setCoursesOptions(
          data.map((row: CourseType) => ({
            value: row.code,
            label: row.code,
            name: row.name,
          })),
        );
        setCourseNamesOptions(
          data.map((row: CourseType) => ({
            value: row.name,
            label: row.name,
            code: row.code,
          })),
        );
      }
      setLoadingCourses(false);
    },
    [setLoadingCourses],
  );

  return {
    coursesOptions,
    courseNamesOptions,
    courses,
    loadingCourses,
    setLoadingCourses,
    facultyOptions,
    campusOptions,
    schedulesOptions,
    loadCourses,
  };
}
